const schedulePt = [
  {
    day: 23,
    schedule: [
      {
        title: 'Palestra de Abertura',
        start: '10:00:00',
      },
      {
        title: 'Keynote Sessions',
        start: '10:30:00',
        end: '12:40:00',
      },
      {
        title: 'Almoço',
        start: '12:40:00',
        end: '14:00:00',
      },
      {
        title: 'Sessão de Palestras e Paineis Interativos',
        start: '14:30:00',
        end: '17:30:00',
      },
    ],
  },
  {
    day: 24,
    schedule: [
      {
        title: 'Varejo / Bancos Digitais',
        start: '09:10:00',
        end: '12:30:00',
      },
      {
        title: 'Almoço',
        start: '12:30:00',
        end: '14:00:00',
      },
      {
        title: 'Cartões / Fintechs',
        start: '14:00:00',
        end: '17:00:00',
      },
    ],
  },
  {
    day: 25,
    schedule: [
      {
        title: 'Workshop I - Cybersecurity / Fraudes',
        start: '09:30:00',
        end: '12:00:00',
      },
      {
        title: 'Almoço',
        start: '12:00:00',
        end: '14:00:00',
      },
      {
        title: 'Workshop II - Estratégia de Marketing Digital',
        start: '14:00:00',
        end: '17:00:00',
      },
    ],
  },
];

export default schedulePt;



/** WEBPACK FOOTER **
 ** ./src/fixtures/schedulePt.js
 **/